"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChartUpdates = void 0;
var React = _interopRequireWildcard(require("react"));
var _datasetUtils = require("./datasetUtils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Хук выполняет обновление data и options графика
 * @see https://www.chartjs.org/docs/latest/developers/updates.html
 *  */
const useChartUpdates = (chartCfg, chart) => {
  React.useEffect(() => {
    if (!(chart && chartCfg)) {
      return;
    }
    const currentDatasets = (0, _datasetUtils.getDatasets)(chart.data.datasets);
    const nextDatasets = (0, _datasetUtils.getDatasets)(chartCfg.data.datasets);

    /** Объекты данных обновляются по частям, чтоб работала анимация на графике */
    if (currentDatasets.offerPriceDataset && nextDatasets.offerPriceDataset?.data) {
      currentDatasets.offerPriceDataset.data = nextDatasets.offerPriceDataset.data;
    }
    if (currentDatasets.estimationPriceDataset && nextDatasets.estimationPriceDataset?.data) {
      currentDatasets.estimationPriceDataset.data = nextDatasets.estimationPriceDataset.data;
    }
    chart.data.datasetsXRange = chartCfg.data.datasetsXRange;

    /** объект опций обновляется целиком */
    chart.options = chartCfg.options;

    /** Если пропсы графика меняются, создается новый конфиг chartCfg, который обновляет график chart */
    chart.update();
  }, [chart, chartCfg]);
};
exports.useChartUpdates = useChartUpdates;